export default __webpack_public_path__ + "static/media/feature8.11fd2684.svg";